import { CreateBookingParams } from "@/features/private-room/bookings/adapters/create-booking/create-booking.types";
import { useEffect, useRef, useState } from "react";
import { Input } from "../input";
import { SearchInputProps } from "./search-input.types";

const searchFilter = (
  searchValue: string,
  optionList: { id: number; name: string }[],
) => {
  const lowerCaseQuery = searchValue?.toLowerCase();
  const filteredList = searchValue
    ? optionList.filter((item) =>
        item.name.toLowerCase().includes(lowerCaseQuery),
      )
    : optionList;
  return filteredList;
};

export const SearchInput = ({
  label,
  optionsList,
  selectOption,
  name,
  searchValue,
  disable,
  ...props
}: SearchInputProps) => {
  const nameKey = name as keyof CreateBookingParams;
  const [visible, setVisible] = useState(false);

  const dropdownRef = useRef(null);

  useEffect(() => {
    document.addEventListener("mousedown", handleClick, false);
    return () => document.removeEventListener("mousedown", handleClick, false);
  }, []);

  const handleClick = (e: Event) => {
    // @ts-expect-error
    if (dropdownRef.current.contains(e.target)) {
      return;
    }
    setVisible(false);
  };

  return (
    <div className="">
      <Input
        {...props}
        label={label}
        className="input"
        type="text"
        onFocus={() => {
          setVisible(true);
        }}
        disable={disable}
      />
      <div ref={dropdownRef} className="relative">
        {visible && (
          <ul className="bg-white rounded-md overflow-y-scroll absolute w-full ring-1 ring-inset ring-gray-300 [&>*:not(:last-child)]:border max-h-[300px]">
            {!optionsList && (
              <li key="zxc" className="p-4">
                no result
              </li>
            )}

            {optionsList &&
              searchFilter(searchValue, optionsList).map((searchItem) => (
                <li
                  key={searchItem.id}
                  onClick={() => selectOption(nameKey, searchItem)}
                  className="p-2 w-full hover:bg-slate-200  border-b-gray-100 cursor-pointer"
                >
                  <div className="">{searchItem.name}</div>
                </li>
              ))}
          </ul>
        )}
      </div>
    </div>
  );
};
